import { render, staticRenderFns } from "./UploadCoverModal.vue?vue&type=template&id=bd28789c&scoped=true&"
import script from "./UploadCoverModal.vue?vue&type=script&lang=js&"
export * from "./UploadCoverModal.vue?vue&type=script&lang=js&"
import style0 from "./UploadCoverModal.vue?vue&type=style&index=0&id=bd28789c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd28789c",
  null
  
)

export default component.exports